
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"oeamtc-icon__chevron-right","viewBox":"0 0 16 16","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.22 3.22a.75.75 0 000 1.06L8.94 8l-3.72 3.72a.75.75 0 001.06 1.06l4.22-4.22a.74.74 0 00.21-.56.74.74 0 00-.21-.56L6.28 3.22a.75.75 0 00-1.06 0z"}})])
          )
        }
      }
    